module.exports = __webpack_public_path__ + "assets/advantages-wallet-1245bb.svg";